import { render } from "./Artwork.vue?vue&type=template&id=4fa26685&scoped=true"
import script from "./Artwork.vue?vue&type=script&lang=js"
export * from "./Artwork.vue?vue&type=script&lang=js"

import "./Artwork.vue?vue&type=style&index=0&id=4fa26685&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4fa26685"

export default script